import {
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
    triggerConstants,
    trackEvent,
} from 'dibs-tracking';

export type SellerBrandingTrackingTrigger =
    | typeof triggerConstants.TRIGGER_SIDERAIL
    | typeof triggerConstants.TRIGGER_SELLER_INFORMATION
    | typeof triggerConstants.TRIGGER_SELLER_DETAILS
    | typeof triggerConstants.TRIGGER_MESSAGE_SELLER
    | typeof triggerConstants.TRIGGER_CALL_SELLER;

export const trackSellerBrandingSiderailClick = (): void => {
    trackEvent({
        eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
        interaction_type: interactionTypeConstants.INTERACTION_TYPE_PDP,
        step_interaction_name: stepInteractionConstants.STEP_INTERACTION_PDP_TAB_CLICKED,
        trigger: triggerConstants.TRIGGER_SIDERAIL_DEALER_CLICK,
    });
};

export const trackSellerBrandingCopied = (trigger: SellerBrandingTrackingTrigger): void => {
    trackEvent({
        eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
        interaction_type: interactionTypeConstants.INTERACTION_TYPE_SELLER_BRANDING,
        step_interaction_name: stepInteractionConstants.STEP_INTERACTION_SELLER_BRANDING_COPIED,
        trigger,
    });
};

export const trackSellerBrandingRightClickMenu = (trigger: SellerBrandingTrackingTrigger): void => {
    trackEvent({
        eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
        interaction_type: interactionTypeConstants.INTERACTION_TYPE_SELLER_BRANDING,
        step_interaction_name:
            stepInteractionConstants.STEP_INTERACTION_SELLER_BRANDING_RIGHT_CLICK_MENU,
        trigger,
    });
};
